import { createApp } from 'vue';

// Fonts self-hosted via fontsource (latin subsets only — the site is pt-BR).
import '@fontsource/space-grotesk/latin-500.css';
import '@fontsource/space-grotesk/latin-700.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/latin-600.css';

import './style.css';
import App from './App.vue';
import { i18n } from './i18n';
import { cipher } from './directives/cipher';

createApp(App).use(i18n).directive('cipher', cipher).mount('#app');